<template>
  <div v-if="rdy">
      <div v-html="task.taskDesc"></div>
    </div>
</template>

<script>
import { request } from "@/api/all";

export default {
  props: {
    comp: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      task: {},
      rdy: false
    };
  },
  mounted() {
    this.init(this.comp.organizationTaskId);
  },
  methods: {
    init(taskId) {
      request({
        api: { method: "GET", url: "task/TaskInheritedDetail" },
        params: { id: taskId },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.task = res.data.task;
          this.rdy = true;
        }
      });
    }
  }
};
</script>

<style></style>
